import { Button, Card } from '@iwoca/orion';
import styles from './CrossSellCard.module.css';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import coinWithArrowSvg from './coinWithArrow.svg';
import {
    useApprovedNotTakenOffers,
    useGetCustomerState
} from '@api/lendingAPI/lapiHooks';
import { OPEN_MODAL } from '@iwModals/Modals.actions';
import { useRef } from 'react';
import { tracking } from '@iwoca/frontend-tracking-library';
import { CROSS_SELL_WARNING_MODAL } from '@iwModals/Modals.constants';
import { useStateKey } from '../../../../iwQueryClient/useStateKey';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    openCrossSellWarningModal: () =>
        dispatch({
            type: OPEN_MODAL,
            id: CROSS_SELL_WARNING_MODAL
        })
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

const RawCrossSellCard = ({ openCrossSellWarningModal }: PropsFromRedux) => {
    const stateKey = useStateKey();
    const { data: customerState, isLoading: loadingCustomerState } =
        useGetCustomerState(stateKey);
    const { approvedNotTakenOffers, loadingApprovedNotTaken } =
        useApprovedNotTakenOffers();

    const hasTrackedView = useRef(false);
    const trackView = () => {
        if (hasTrackedView.current) return;
        hasTrackedView.current = true;

        tracking.ampli.buyerDisplayedXSellBanner();
    };

    const isSoleTrader =
        customerState?.application?.company?.type === 'sole_trader';

    if (loadingApprovedNotTaken || loadingCustomerState) return null;
    if (approvedNotTakenOffers && approvedNotTakenOffers.length > 0)
        return null;
    if (isSoleTrader) return null;

    trackView();

    return (
        <Card className={styles.CrossSellCard}>
            <div className={styles.iconWrapper}>
                <img src={coinWithArrowSvg} height="98" width="auto" alt="" />
            </div>
            <div>
                <h2 className={styles.header}>Want to ease your cashflow?</h2>
                <p>
                    Apply for an iwoca Flexi-Loan in minutes and you could have
                    the funds in your bank account within hours.
                </p>
                <Button variant="primary" onClick={openCrossSellWarningModal}>
                    Apply now
                </Button>
            </div>
        </Card>
    );
};

export const CrossSellCard = connect(
    null,
    mapDispatchToProps
)(RawCrossSellCard);
